/**
 * Formats a raw phone number into a cleaner, more readable format
 * Works on long and short phone numbers
 * ie. 12345678910 -> 1-234-567-8910
 * and 2345678910 -> 234-567-8910
 * @param {number|string} phone Phone number to format
 * @param {string} joiner Character to join the number when formatting, default '-'
 * @returns {string} The formatted phone number
 */
export default function formatPhoneNumber(phone, joiner = '-') {
    // Remove any non-digit characters, and assert number as string
    const cleanNumber = String(phone).replace(/[^\d]/g, '');

    // Validate the number has the correct amount of digits
    if (cleanNumber.length < 10 || cleanNumber.length > 11) {
        const numberLog = cleanNumber == phone
            ? `'${cleanNumber}'`
            : `'${cleanNumber}' (original: '${phone}')`;

        // Logging instead of throwing an Error so this doesn't crash the app
        // eslint-disable-next-line no-console
        console.warn(
            '[formatPhoneNumber] Expected phone number to be 10 or 11 digits in length, '
            + `but ${numberLog} of length ${cleanNumber.length} was supplied.`,
        );

        return phone;
    }

    // Regexp to format phone number
    // ^.(?=\d{10}) captures the first digit if it is followed by 10 digits, will get the '1'
    // \d{4}$ captures the four digits at the end of the number
    // \d{3} captures groups of three digits
    const formatExpression = /^.(?=\d{10})|\d{4}$|\d{3}/g;

    return cleanNumber.match(formatExpression).join(joiner);
}
